/** @jsxImportSource @emotion/react */
import { Box, css, IconButton, Link, Theme, useTheme } from '@mui/material'
import { ArrowLeftCircle } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { header } from '../styles/DataLayerDetailPage.styles'

const DataLayerDetailHeader = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box data-testid="risk-data-detail-page-header" css={header}>
      {children}
    </Box>
  )
}

export default DataLayerDetailHeader

export const DataLayerDetailHeaderBackButton = () => {
  const navigate = useNavigate()
  const handleBackClick = () => {
    navigate(-1)
  }

  return (
    <Link component="button" underline="none" onClick={handleBackClick}>
      <Box css={RiskDataBackButton}>
        <IconButton aria-label="Go back" onClick={handleBackClick}>
          <ArrowLeftCircle />
        </IconButton>
        Back
      </Box>
    </Link>
  )
}

export const DataLayerDetailHeaderTitle = ({ displayName }: { displayName?: string }) => {
  const theme = useTheme()
  return (
    <Box css={riskDataBannerTitle({ theme })}>
      <h1>{displayName || ''}</h1>
    </Box>
  )
}

// Styles

export const riskDataBannerTitle = ({ theme }: { theme: Theme }) => css`
  padding: ${theme.spacing(1)} 0;
  padding-bottom: ${theme.spacing(2)};
  color: ${theme.palette.black.main};
  text-align: left;
  position: relative;

  h1 {
    line-height: 1.2;
    font-size: 18px;
    font-weight: 700;
    padding-left: 20px;
    text-shadow:
      0 0 16px rgba(0, 0, 0, 0.1),
      -1px 0 0 #fff8;
  }
`
export const RiskDataBackButton = css`
  padding: 2px 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.18s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`
